import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { crearSucursal } from 'scripts/crearSucursal';
import { actualizarSucursal } from 'scripts/actualizarSucursal';
import { borrarSucursal } from 'scripts/borrarSucursal';
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Button,
	Paper,
	TextField,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	InputAdornment,
	Box,
	Grid,
	Checkbox,
	FormControlLabel,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { obtenerSucursales } from 'scripts/obtenerSucursales';
import { toast } from 'react-toastify';
import CustomDialog from 'helpers/Dialog';
import { subirImagenAFirebase } from 'scripts/firebaseUpload';

const SucursalManagement = () => {
	const dispatch = useDispatch();
	const sucursales = useSelector((state) => state.sucursales);

	const fetchSucursales = async () => {
		obtenerSucursales(dispatch).catch((e) => {
			toast.error(e.message);
		});
	};

	const [open, setOpen] = useState(false);
	const [newSucursal, setNewSucursal] = useState({
		id: null,
		nombre: '',
		direccion: '',
		telefono: '',
		mensaje_retiro: '',
		hora_apertura: '',
		hora_cierre: '',
		imagen: '',
		pick_up: true,
	});
	const [searchTerm, setSearchTerm] = useState('');
	const [searchDireccion, setSearchDireccion] = useState('');
	const [dialogOpen, setDialogOpen] = useState(false);
	const [id, setId] = useState(null);

	const handleOpenDialog = (id) => {
		setId(id);
		setDialogOpen(true);
	};

	const handleCloseDialog = () => {
		setId(null);
		setDialogOpen(false);
	};

	const handleConfirmDialog = () => {
		borrarSucursal(id, sessionStorage.getItem('token'))
			.then((data) => {
				toast.success('Sucursal eliminada correctamente.');
				fetchSucursales();
			})
			.catch((error) => {
				toast.error('Error al eliminar la sucursal.');
			});
		setDialogOpen(false);
	};

	const handleImageChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			setNewSucursal((prevState) => ({
				...prevState,
				imagen: file,
			}));
		}
	};

	useEffect(() => {
		try {
			fetchSucursales();
		} catch (e) {
			console.log(e);
		}
	}, []);

	const handleOpen = (sucursal = null) => {
		if (sucursal) {
			setNewSucursal({
				id: sucursal.id,
				nombre: sucursal.nombre,
				direccion: sucursal.direccion,
				telefono: sucursal.telefono || '',
				mensaje_retiro: sucursal.mensaje_retiro || '',
				hora_apertura: sucursal.hora_apertura || '',
				hora_cierre: sucursal.hora_cierre || '',
				imagen: sucursal.imagen || '',
				pick_up: sucursal.pick_up !== undefined ? sucursal.pick_up : true,
			});
		} else {
			setNewSucursal({
				id: null,
				nombre: '',
				direccion: '',
				telefono: '',
				mensaje_retiro: '',
				hora_apertura: '',
				hora_cierre: '',
				imagen: '',
				pick_up: true,
			});
		}
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setNewSucursal({ ...newSucursal, [name]: value });
	};

	const handleSaveSucursal = async () => {
		if (newSucursal.nombre && newSucursal.direccion) {
			let imageUrl = newSucursal.imagen === null ? '' : newSucursal.imagen;

			// Si hay un nuevo archivo seleccionado, subirlo a Firebase
			if (
				newSucursal.imagen !== null &&
				newSucursal.imagen !== undefined &&
				typeof newSucursal.imagen !== 'string'
			) {
				imageUrl = await subirImagenAFirebase(newSucursal.imagen);
			}

			if (newSucursal.id === null) {
				crearSucursal(
					newSucursal.nombre,
					newSucursal.direccion,
					newSucursal.telefono,
					newSucursal.mensaje_retiro,
					newSucursal.hora_apertura,
					newSucursal.hora_cierre,
					imageUrl,
					newSucursal.pick_up,
					sessionStorage.getItem('token'),
				)
					.then((data) => {
						toast.success('Sucursal creada correctamente.');
						fetchSucursales();
					})
					.catch((error) => {
						toast.error('Error al crear la sucursal.');
					});
			} else {
				actualizarSucursal(
					newSucursal.id,
					newSucursal.nombre,
					newSucursal.direccion,
					newSucursal.telefono,
					newSucursal.mensaje_retiro,
					newSucursal.hora_apertura,
					newSucursal.hora_cierre,
					imageUrl,
					newSucursal.pick_up,
					sessionStorage.getItem('token'),
				)
					.then((data) => {
						toast.success('Sucursal actualizada correctamente.');
						fetchSucursales();
					})
					.catch((error) => {
						toast.error('Error al actualizar la sucursal.');
					});
			}
			handleClose();
		} else {
			toast.error('Por favor, complete los campos obligatorios (nombre y dirección).');
		}
	};

	const filteredSucursales = sucursales.filter((sucursal) => {
		return (
			sucursal.nombre.toLowerCase().includes(searchTerm.toLowerCase()) &&
			sucursal.direccion.toLowerCase().includes(searchDireccion.toLowerCase())
		);
	});

	return (
		<div style={{ marginTop: '20px' }}>
			{/* Barra de búsqueda y botón "Agregar" */}
			<Box sx={{ marginBottom: 2, paddingBottom: 2, borderBottom: '2px solid #ccc' }}>
				<Grid container spacing={2} alignItems="center">
					{/* Botón de agregar */}
					<Grid item xs={12} sm={2} md={1}>
						<Button variant="contained" color="success" onClick={() => handleOpen()}>
							<AddIcon />
						</Button>
					</Grid>

					{/* Buscador por nombre */}
					<Grid item xs={12} sm={6} md={3}>
						<TextField
							label="Buscar por nombre"
							variant="outlined"
							fullWidth
							value={searchTerm}
							onChange={(e) => setSearchTerm(e.target.value)}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<SearchIcon />
									</InputAdornment>
								),
							}}
						/>
					</Grid>

					{/* Buscador por dirección */}
					<Grid item xs={12} sm={6} md={3}>
						<TextField
							label="Buscar por dirección"
							variant="outlined"
							fullWidth
							value={searchDireccion}
							onChange={(e) => setSearchDireccion(e.target.value)}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<SearchIcon />
									</InputAdornment>
								),
							}}
						/>
					</Grid>
				</Grid>
			</Box>

			{/* Tabla de sucursales con Scrollbar */}
			<TableContainer component={Paper} sx={{ maxHeight: 400, overflow: 'auto' }}>
				<Table>
					<TableHead sx={{ position: 'sticky', top: 0, backgroundColor: '#FFFFFF', zIndex: 1 }}>
						<TableRow>
							<TableCell>Nombre</TableCell>
							<TableCell>Dirección</TableCell>
							<TableCell>Teléfono</TableCell>
							<TableCell>Horario</TableCell>
							<TableCell>Pick-Up</TableCell>
							<TableCell>Acciones</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{filteredSucursales.length > 0 ? (
							filteredSucursales.map((sucursal) => (
								<TableRow key={sucursal.id}>
									<TableCell>{sucursal.nombre}</TableCell>
									<TableCell>{sucursal.direccion}</TableCell>
									<TableCell>{sucursal.telefono || '-'}</TableCell>
									<TableCell>
										{sucursal.hora_apertura && sucursal.hora_cierre
											? `${sucursal.hora_apertura} - ${sucursal.hora_cierre}`
											: '-'}
									</TableCell>
									<TableCell
										style={{ color: sucursal.pick_up ? 'green' : 'red', fontWeight: 'bold' }}
									>
										{sucursal.pick_up ? '✓' : '✗'}
									</TableCell>
									<TableCell>
										<Button
											variant="outlined"
											color="primary"
											onClick={() => handleOpen(sucursal)}
											sx={{ marginRight: 2 }}
										>
											Editar
										</Button>
										<Button
											variant="outlined"
											color="secondary"
											onClick={() => handleOpenDialog(sucursal.id)}
										>
											Eliminar
										</Button>
									</TableCell>
								</TableRow>
							))
						) : (
							<TableRow>
								<TableCell colSpan={5} style={{ textAlign: 'center' }}>
									No hay sucursales disponibles.
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>

			{/* Formulario para agregar o editar sucursal */}
			<Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
				<DialogTitle>{newSucursal.id ? 'Editar Sucursal' : 'Agregar Sucursal'}</DialogTitle>
				<DialogContent>
					<Box sx={{ mt: 2 }}>
						<TextField
							label="Nombre *"
							name="nombre"
							value={newSucursal.nombre}
							onChange={handleInputChange}
							fullWidth
							sx={{ marginBottom: 2 }}
						/>
						<TextField
							label="Dirección *"
							name="direccion"
							value={newSucursal.direccion}
							onChange={handleInputChange}
							fullWidth
							sx={{ marginBottom: 2 }}
						/>
						<TextField
							label="Teléfono"
							name="telefono"
							value={newSucursal.telefono}
							onChange={handleInputChange}
							fullWidth
							sx={{ marginBottom: 2 }}
						/>
						<TextField
							label="Mensaje de Retiro"
							name="mensaje_retiro"
							value={newSucursal.mensaje_retiro}
							onChange={handleInputChange}
							fullWidth
							multiline
							minRows={3}
							placeholder="Ej: Retiros por Pocitos entre 18 y 21hs, en caso de querer retirar antes consultar por Whatsapp"
							sx={{ marginBottom: 2 }}
						/>
						<TextField
							label="Hora de Apertura"
							name="hora_apertura"
							type="time"
							value={newSucursal.hora_apertura}
							onChange={handleInputChange}
							fullWidth
							InputLabelProps={{ shrink: true }}
							sx={{ marginBottom: 2 }}
						/>
						<TextField
							label="Hora de Cierre"
							name="hora_cierre"
							type="time"
							value={newSucursal.hora_cierre}
							onChange={handleInputChange}
							fullWidth
							InputLabelProps={{ shrink: true }}
							sx={{ marginBottom: 2 }}
						/>
						<Box sx={{ marginBottom: 2 }}>
							<label htmlFor="imagen-upload">Imagen</label>
							<input
								id="imagen-upload"
								type="file"
								accept="image/*"
								onChange={handleImageChange}
								style={{ marginTop: '10px', display: 'block' }}
							/>
						</Box>
						<FormControlLabel
							control={
								<Checkbox
									checked={newSucursal.pick_up}
									onChange={(e) => setNewSucursal({ ...newSucursal, pick_up: e.target.checked })}
									name="pick_up"
								/>
							}
							label="Habilitada para retiro (Pick-Up)"
						/>
					</Box>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="secondary">
						Cancelar
					</Button>
					<Button onClick={handleSaveSucursal} color="primary">
						{newSucursal.id ? 'Guardar Cambios' : 'Agregar'}
					</Button>
				</DialogActions>
			</Dialog>

			<CustomDialog
				open={dialogOpen}
				title="Confirmar eliminación"
				content="¿Está seguro de que desea eliminar esta sucursal?"
				onClose={handleCloseDialog}
				onConfirm={handleConfirmDialog}
			/>
		</div>
	);
};

export default SucursalManagement;
